import { Link } from 'react-router-dom';
import { BowArc } from '@/components/ui/BowArc';
import { Eyebrow } from '@/components/ui/Typography';

// Trilho de arco vertical (180°) — assinatura da marca na borda esquerda.
const ARC_RAIL =
  'linear-gradient(180deg,#EE263E,#DE7C00,#FFB92A,#00C072,#0090E2,#835DD0,#8345BA)';

/**
 * Card de captação da Aliança na Home — variante "enxuta · uma linha".
 *
 * Renderizado abaixo da lista de estações, SÓ para não-membros (o gate fica no
 * caller, via `me.adesao_disponivel`). Surface inteira clicável → /alianca.
 *
 * Slim 2026-07-02 (feedback Saulo): pill "Aderir" virou seta compacta (o card
 * todo já navega), título encurtado pra "Até 30% de cashback" e eyebrow
 * ganhou "Fidelidade" (feedback cliente nº 3 — ninguém sabia o que era
 * Aliança). Subtítulo removido.
 */
export function AliancaHomeCard() {
  return (
    <Link
      to="/alianca"
      className="relative flex items-center gap-3 overflow-hidden rounded-[22px] bg-white py-3 pl-4 pr-3.5 [@media(max-height:740px)]:py-2.5"
      style={{ boxShadow: '0 1px 2px rgba(0,27,116,0.04), 0 6px 16px rgba(0,27,116,0.06)' }}
    >
      <span aria-hidden className="absolute inset-y-0 left-0 w-[5px]" style={{ background: ARC_RAIL }} />
      <span className="shrink-0 pl-1">
        <BowArc size={40} variant="gradient" spin />
      </span>
      <div className="min-w-0 flex-1">
        <Eyebrow>Fidelidade Bow</Eyebrow>
        <div
          className="mt-0.5 truncate leading-[1.1] text-bow-royal [@media(max-height:740px)]:!text-[15px]"
          style={{
            fontFamily: 'Chillax, system-ui, sans-serif',
            fontWeight: 500,
            fontSize: 17,
            letterSpacing: '-0.02em'
          }}
        >
          Até <span style={{ color: '#00A664' }}>30% de cashback</span>
        </div>
      </div>
      <span className="inline-flex h-10 shrink-0 items-center gap-1.5 rounded-full bg-bow-royal px-[17px] text-[14px] font-semibold text-bow-cream">
        Aderir
        <ArrowIcon />
      </span>
    </Link>
  );
}

function ArrowIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}
